import commonApi from './CommonApi.js';
export default {	
	getDropdownItems: async (parameters) => {
		return await commonApi().get('/symbols/get-dropdown-items', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	}
}